import React, { useEffect, useRef, useState } from "react";
import "./css/Buyback.css"; // Import separate CSS file
import { usePopupStack } from "../../contexts/PopupStackContext";
import {useRefreshContext} from "@portfolio/context/RefreshContext";
import {deleteContractNote, fetchManualContractNoteNo, saveContractNote} from "@portfolio/utils/PFService";

const Buyback = ({ symbol: initialSymbol, onClose, onSave, isDisplayClick, contractNoteDTO, clientId }) => {
    const [date, setDate] = useState(new Date().toISOString().split("T")[0]);
    const [quantity, setQuantity] = useState("");
    const [price, setPrice] = useState("");
    const [amount, setAmount] = useState("");
    const [symbol, setSymbol] = useState(initialSymbol);
    const formRef = useRef(null);
    const { refreshPFdata } = useRefreshContext();
    const { push, pop } = usePopupStack();

    useEffect(() => {
        const popupEntry = { onClose }; // 🔥 Use the prop directly
        push(popupEntry);
        return () => pop();
    }, []);

    const handleClose = () => {
        pop(); // 🧹 Make sure to remove this popup from the stack manually
        onClose();
    };

    useEffect(() => {
        if (isDisplayClick && contractNoteDTO?.transactions?.length > 0) {
            const txn = contractNoteDTO.transactions[0];
            setQuantity(txn.quantity);
            setPrice(txn.weightedAvgPrice);
            setAmount(txn.totalValue);
            setDate(txn.tradeDate);
            setSymbol(txn.symbol);
        }
    }, []);

    const handleSave = async () => {
        if (!symbol || symbol.trim() === "") {
            alert("Please enter a valid script name.");
            return;
        }

        if (!quantity || isNaN(quantity) || quantity <= 0) {
            alert("Please enter a valid quantity.");
            return;
        }

        const parsedQuantity = parseInt(quantity, 10);
        const parsedPrice = parseFloat(price);
        const parsedAmount = parseFloat(amount);

        let manualNote = contractNoteDTO?.contractNote?.contractNoteNo || "";
        if (!isDisplayClick) {
            manualNote = await fetchManualContractNoteNo("BUYBACK-CNT-");
        }

        const newContractNote = {
            contractNote: {
                contractNoteNo: manualNote,
                clientId: clientId,
                brokerName: "",
                tradeDate: date,
                cnoteType: "BUYBACK",
            },
            cnotesCharge: {
                contractNoteNo: "",
                securitiesTransactionTaxEquity: "",
                stampDutyEquity: "",
                igstEquity: "",
                exchangeTransactionChargesEquity: "",
                otherCharges: "",
                netAmountNetTotal: 0.0,
            },
            transactions: [
                {
                    type: "BuybackTransactionDTO",
                    contractNoteNo: manualNote,
                    clientId: clientId,
                    symbol: symbol,
                    transactionType: "Buyback",
                    quantity: parsedQuantity,
                    weightedAvgPrice: parsedPrice,
                    brokerage:0,
                    totalValue: parsedAmount,
                    netQuantity: -parsedQuantity, // Negative for Sell, Positive for Buy
                    netObligation: -parsedAmount,
                    tradeDate: date,
                    narration: ""
                }
            ],
            cnoteType: "BUYBACK"
        };

        try {
            const result = await saveContractNote(newContractNote, isDisplayClick);
            if (result.success) {
                refreshPFdata();
                onSave(newContractNote);
                onClose();
            }
        } catch (error) {
            console.error("Error saving Buyback:", error);
        }
    };

    const handleDelete = async () => {
        try {
            const result = await deleteContractNote(contractNoteDTO.contractNote.contractNoteNo);
            if (result.success) {
                refreshPFdata();
                onClose();
            }
        } catch (error) {
            console.error("Error deleting Buyback:", error);
        }
    };

    return (
        <div className="popup-overlay merger-overlay">
            <form ref={formRef}>
                <div className="merger-popup" onClick={(e) => e.stopPropagation()}>
                    <div className="header-row">
                        <h3>Buyback</h3>
                        <h3>{clientId}</h3>
                    </div>

                    <div className="form-group">
                        <label className="general-label">Transaction:</label>
                        <input type="text" value="Buyback" disabled />
                    </div>

                    <div className="form-group">
                        <label className="general-label">Script:</label>
                        <input
                            type="text"
                            value={symbol}
                            onChange={(e) => setSymbol(e.target.value)}
                        />
                    </div>

                    <h5>Transaction:</h5>

                    <div className="form-group">
                        <label className="general-label">Date:</label>
                        <input name="date" type="date" value={date} onChange={(e) => setDate(e.target.value)} />
                    </div>

                    <div className="form-group">
                        <label className="general-label">Quantity:</label>
                        <input
                            type="number"
                            value={quantity}
                            onChange={(e) => setQuantity(e.target.value)}
                            min="1"
                        />
                    </div>

                    <div className="form-group">
                        <label className="general-label">Price:</label>
                        <input
                            type="number"
                            value={price}
                            onChange={(e) => setPrice(e.target.value)}
                            step="0.01"
                            min="0"
                        />
                    </div>

                    <div className="form-group">
                        <label className="general-label">Amount:</label>
                        <input
                            type="number"
                            value={amount}
                            onChange={(e) => setAmount(e.target.value)}
                            step="0.01"
                            min="0"
                        />
                    </div>

                    <div className="contract-buttons">
                        {isDisplayClick && (
                            <button type="button" className="delete-button" onClick={handleDelete}>
                                Delete CNote
                            </button>
                        )}
                        <div className="right-buttons">
                            <button type="button" className="save-button" onClick={handleSave}>Save</button>
                            <button type="button" className="cancel-button" onClick={onClose}>Cancel</button>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    );
};

export default Buyback;